<template>
  <v-autocomplete
    required
    :multiple="multiple"
    :rules="rules"
    :items="list"
    v-model="select"
    @change="_fnChange"
    :readonly="readonly"
    :clearable="!readonly && !rules"
  >
    <template #label>
      {{ $t(`table.status`) }}
      <span class="red--text" v-if="rules">
        <strong>*</strong>
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  model: {
    prop: "selected",
    event: "change",
  },
  props: {
    selected: [String, Array],
    rules: Array,
    multiple: Boolean,
    readonly: Boolean,
  },
  data() {
    return {
      select: "",
      list: [],
    };
  },
  watch: {
    selected: function () {
      this.select = this.selected || "";
    },
  },
  created() {
    this.list = this.Constant.obj["STATUS_DISCOVERY"].map((e) => ({
      text: e.name,
      value: e.id,
    }));
    this.select = this.selected || "";
  },
  methods: {
    _fnChange() {
      this.$emit("change", this.select);
    },
  },
};
</script>
